import { twMerge } from "@/utils/twMerge";

import { CollapseToggle } from "./CollapseToggle";

import type { MouseEventHandler } from "react";

type Props = {
  nodeTypeName?: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
};

export function CollapsedLine({ nodeTypeName, className, onClick, onMouseDown }: Props) {
  return (
    <div
      className={twMerge(
        "line-wrapper is-collapsed group/line relative mx-auto max-w-content-width w-full sm:max-w-full cursor-pointer",
        className,
        "sm:-my-1.5 fromSm:-my-3.5",
      )}
    >
      <div
        className="flex flex-1 items-center sm:-mx-[6px] fromSm:-mx-2 cursor-pointer"
        contentEditable={false}
      >
        <div className="group/line flex flex-1 items-center min-w-0 sm:max-w-full">
          <div className="flex items-center shrink-0 select-none">
            <CollapseToggle
              collapsed
              nodeTypeName={nodeTypeName}
              onClick={onClick}
              onMouseDown={onMouseDown}
            />
          </div>
          <div className="collapse-rule flex-1 h-0.5 rounded-r bg-transparent transition-colors" />
        </div>
      </div>
    </div>
  );
}
